const pako = require('pako') //import不可以
import { TarReader } from "./tarball"


export async function resolveTarFile(data, endName) {
  const byteArray = new Uint8Array(data); // 切换数据编码为Uint8Array
	const pakoArr = pako.ungzip(byteArray);

  //解压.tar
	const treader = new TarReader();
  const tarContent = await treader.readFile(new File([pakoArr.buffer],'tarFile')).then( async res =>  {
    for (const item of res) {
     if (item.name.endsWith(endName)) {
        if (endName.endsWith(".tarpt.gz")) {
          const byteArray = treader.getFileBinary(item.name) 
          const pakoArr = pako.ungzip(byteArray);
          const decoder = new TextDecoder();
          const contentStr = decoder.decode(pakoArr);
          console.log(contentStr); // 输
          return contentStr
        } else {
          const contentStr = treader.getTextFile(item.name)
          console.log(contentStr)
          return contentStr
        }
      }
    }
  })
  return tarContent
}


//单独封装的
//此处files可以是[接口返回的文件流]，也可以是input选择的文件信息中e.target.files
//type可传''
function jsReadGZFiles(files,type) {
  return new Promise(function(resolve, reject){
    let blob = new Blob(files, { type })
    let reader = new FileReader();
        reader.onload = function () {
            resolve(reader.result)
        };
        reader.onerror = function () {
          reject(reader.result)
        }
        reader.readAsArrayBuffer(blob);
  })
}

//input读取的压缩包,
export async function getGZFileContent(e) {
	//解压.gz
  //.target.files
  console.log("e === ", e)
	let res = await jsReadGZFiles(e) //如果后端返回的文件流，可直接[文件流]替换这里的e.target.files
	const byteArray = new Uint8Array(res); // 切换数据编码为Uint8Array
	const pakoArr = pako.ungzip(byteArray);
	//解压.tar
	const treader = new TarReader();
  await treader.readFile(new File([pakoArr.buffer],'test')).then( res => {
    for (const item of res) {
        console.log("item = ", item)
        const contentStr = treader.getTextFile(item.name)
        console.log("contentStr ==== ", contentStr)
    }
  }).catch(() => {

  })

}